import { redirect } from "@tanstack/react-router";
import { catalogContactRedirect } from "./contact-redirect";

export const catalogContactRoute = {
    beforeLoad: ({ params }: { params: { dogId: string } }) => {
        throw redirect(catalogContactRedirect(params.dogId));
    },
};
